(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    /* Initialize wishlist icons state on page load */
    document.addEventListener('DOMContentLoaded', () => {
      const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
      const wishlistButtons = document.querySelectorAll('.wishlist-button-collection');
      
      wishlistButtons.forEach(btn => {
        const onclick = btn.getAttribute('onclick');
        if (onclick) {
          const titleMatch = onclick.match(/'([^']+)'/);
          if (titleMatch) {
            const productTitle = titleMatch[1];
            const isInWishlist = wishlistData.some(item => item.productTitle === productTitle);
            if (isInWishlist) {
              btn.classList.add('active');
            }
          }
        }
      });
    });

    /* FULL CARD CLICK - EXCLUDE BUTTONS */
    document.addEventListener('click', function (e) {
      if (
        e.target.closest('.quick-add-wrapper-recs') ||
        e.target.closest('.wishlist-button-collection') ||
        e.target.closest('button') ||
        e.target.closest('form') ||
        e.target.closest('input') ||
        e.target.closest('select') ||
        e.target.closest('a')
      ) {
        return;
      }

      const overlay = e.target.closest('.card-click-overlay');
      const card = e.target.closest('.product-card');

      if (overlay || (card && !e.target.closest('.product-info'))) {
        const productCard = overlay ? overlay.closest('.product-card') : card;
        if (productCard && productCard.dataset.productUrl) {
          window.location.href = productCard.dataset.productUrl;
        }
      }
    });
  })();
  
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
